<template>
  <section class="bg-white py-20 md:py-28">
    <div class="mx-auto max-w-6xl px-4 md:px-6">
      <div class="mb-14 text-center">
        <h2 class="text-4xl font-bold leading-[1.05] tracking-tight text-foreground md:text-5xl">
          {{ $ts('consultationTypes.title') }}
        </h2>
        <p class="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
          {{ $ts('consultationTypes.subtitle') }}
        </p>
      </div>

      <!-- Two modes: in-clinic + online -->
      <div class="mb-8 grid gap-5 md:grid-cols-2">
        <!-- In-clinic visits -->
        <div class="flex flex-col rounded-3xl border border-border/50 bg-white p-7">
          <div class="mb-4 flex items-center gap-3">
            <Icon name="tabler:building-hospital" size="28" class="shrink-0 text-vet" />
            <h3 class="text-base font-bold text-foreground">{{ $ts('consultationTypes.inClinic.title') }}</h3>
          </div>
          <p class="text-sm leading-relaxed text-muted-foreground">{{ $ts('consultationTypes.inClinic.description') }}</p>
          <ul class="mt-4 space-y-2">
            <li v-for="point in inClinicPoints" :key="point" class="flex items-center gap-2 text-sm text-foreground">
              <Icon name="tabler:circle-check" size="15" class="shrink-0 text-vet" />
              {{ point }}
            </li>
          </ul>
        </div>

        <!-- Online consultations -->
        <div class="flex flex-col rounded-3xl border border-border/50 bg-white p-7">
          <div class="mb-4 flex items-center gap-3">
            <Icon name="tabler:device-laptop" size="28" class="shrink-0 text-foreground" />
            <h3 class="text-base font-bold text-foreground">{{ $ts('consultationTypes.online.title') }}</h3>
          </div>
          <p class="text-sm leading-relaxed text-muted-foreground">{{ $ts('consultationTypes.online.description') }}</p>
          <ul class="mt-4 space-y-2">
            <li v-for="point in onlinePoints" :key="point" class="flex items-center gap-2 text-sm text-foreground">
              <Icon name="tabler:circle-check" size="15" class="shrink-0 text-foreground" />
              {{ point }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Online consultation format cards -->
      <div class="grid gap-5 md:grid-cols-3">
        <div
          v-for="type in types"
          :key="type.key"
          class="flex flex-col rounded-3xl border border-border/50 bg-white p-6 transition-transform hover:scale-[1.005]"
        >
          <div class="mb-4 flex items-center gap-3">
            <Icon :name="type.icon" size="28" :class="['shrink-0', type.color]" />
            <h3 class="text-base font-bold text-foreground">{{ $ts(`consultationTypes.${type.key}.title`) }}</h3>
          </div>
          <p class="text-sm leading-relaxed text-muted-foreground">{{ $ts(`consultationTypes.${type.key}.description`) }}</p>
          <p class="mt-4 text-sm font-semibold text-foreground">{{ $ts(`consultationTypes.${type.key}.price`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '#imports';

const { $ts } = useI18n();

const inClinicPoints = computed(() => [
  $ts('consultationTypes.inClinic.point1'),
  $ts('consultationTypes.inClinic.point2'),
  $ts('consultationTypes.inClinic.point3'),
]);

const onlinePoints = computed(() => [
  $ts('consultationTypes.online.point1'),
  $ts('consultationTypes.online.point2'),
  $ts('consultationTypes.online.point3'),
]);

const types = [
  { key: 'chat',      icon: 'tabler:message',      color: 'text-foreground' },
  { key: 'video',     icon: 'tabler:video',         color: 'text-foreground' },
  { key: 'emergency', icon: 'tabler:alert-circle',  color: 'text-red-500' },
];
</script>
